<template>
    <b-modal
        :id="modalID"
        :title="$t('assignment.change_name')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :size="size"
        @ok="onOk"
        @show="onShow()"
        modal-class="apprentice-default-modal">
        <div v-if="portfolioIn.worldmap">
            <design-2021-worldmap-component
                @country-tabbed="setCountry($event)"
                :use-in="'country-picker'"
                :countries-in="countries"
                :selected-continent-in="portfolioIn.categories[0].continent"
                @setup-continent="setupContinent"
                ref="worldmap-component"></design-2021-worldmap-component>

            <br />
        </div>
        <div class="update-assignment-title">
            <b-alert
                v-if="hasError"
                variant="danger"
                show>
                {{ errorMessage }}
            </b-alert>
            <b-form-group
                :label="$t('common.name')"
                label-for="assignment-title-input">
                <b-form-input
                    id="assignment-title-input"
                    v-model="name"
                    :placeholder="$t('assignment.type_the_name_of_the_assignment_below')">
                </b-form-input>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import Design2021WorldmapComponent from '../../../worldmap/design-2021-worldmap-component.vue';
import { worldmapData } from '../../../../helpers/worldmapData';
import Design2021PortfolioEditUpdateCategoryModalComponent from '../../../portfolio/edit/modals/design-2021-portfolio-edit-update-category-modal-component.vue';

const defaultSelectionColor = '#07A1FF';

export default {
    name: 'design-2021-assignment-edit-name-edit-modal-component',
    components: { Design2021PortfolioEditUpdateCategoryModalComponent, Design2021WorldmapComponent },
    props: {
        assignmentIn: {
            type: Object,
            required: true,
        },
        portfolioIn: {
            type: Object,
        },
    },
    data() {
        return {
            name: this.assignmentIn.name,
            hasError: false,
            errorMessage: '',
            country: this.assignmentIn.country,
            size: this.portfolioIn.worldmap ? 'xl' : 'md',
            color: this.assignmentIn.color,
            modalID: 'assignment-name-edit-modal',
        };
    },
    computed: {
        countries() {
            let countries = {};

            Object.keys(worldmapData.countries).forEach((countryCode) => {
                countries[countryCode] = {
                    country: countryCode,
                    countryName: worldmapData.countries[countryCode].country,
                    state: 'none',
                };
            });

            this.portfolioIn.categories[0].assignments.map((assignment) => {
                if (assignment.country) {
                    countries[assignment.country].country = assignment.country;
                    countries[assignment.country].statusColor = null;
                    countries[assignment.country].assignmentName = assignment.name;
                    countries[assignment.country].state =
                        assignment.id === this.assignmentIn?.id
                            ? 'selected'
                            : assignment.id !== null
                              ? 'blocked'
                              : 'none';
                }
            });

            return countries;
        },
    },
    methods: {
        onShow() {
            this.name = this.assignmentIn.name;
            this.country = this.assignmentIn.country;
            this.color = this.assignmentIn.color ?? defaultSelectionColor;
            this.hasError = false;
        },

        setCountry(country) {
            this.country = country !== this.country ? country : null;
            this.$refs['worldmap-component'].changeSelectedCountry(this.country);
        },
        onOk(bvModalEvent) {
            this.checkForErrors();

            if (this.hasError) {
                bvModalEvent.preventDefault();
                return;
            }

            this.alert.notice();

            const data = {
                name: this.name,
                country: this.country,
                color: this.color,
            };

            this.axios.post(this.routes.assignmentUpdate(this.assignmentIn.id), data).then(
                (response) => {
                    this.$emit('assignment-map-update', data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        checkForErrors() {
            this.hasError = false;

            if (!this.name) {
                this.hasError = true;
                this.errorMessage = this.$t('assignment.name_cannot_be_empty');
            }

            if (this.name && this.name.length > 192) {
                this.hasError = true;
                this.errorMessage = this.$t('assignment.name_sub_assignment_may_not_contain_more_than_191_characters');
            }
        },
        revertChanges() {
            this.$refs['worldmap-component'].changeSelectedCountry(this.assignmentIn?.country); // revert map selection
        },

        setupContinent() {
            this.$bvModal.hide(this.modalID);
            this.$emit('setup-continent');
        },
    },
    mounted() {
        this.$root.$on('bv::modal::hide', (bvEvent, modalID) => {
            if (bvEvent.trigger !== 'ok' && modalID === this.modalID) {
                this.revertChanges();
            }
        });
    },
};
</script>

<style scoped></style>
